
<template>
    <div class="collectView">
        <div class="collectBlock">
            <div class="top" v-if="!bohui">
                <div class="topA">我的资源/试题/班会</div>
                <div class="topB">
                    <!-- status 状态:1=待审核,2=已通过,3=驳回(不传为全部) -->
                    <div :class="idx == 1 ? 'topB1' : 'topB2'" @click="goTab(1)">全部</div>
                    <div :class="idx == 2 ? 'topB1' : 'topB2'" @click="goTab(2)">待审核/已通过</div>
                    <div :class="idx == 3 ? 'topB1' : 'topB2'" @click="goTab(3)">驳回</div>
                </div>
            </div>
            <div v-if="bohui" class="bohui" @click="bohui = false">
                <img src="@/assets/images/goback.png" alt="" />
                <span>返回</span>
            </div>
            <div v-if="!bohui" class="tabView" v-for="(item, index) in pageList" :key="index" @click="goXX(item)">
                <div class="tabViewBlock">
                    <div class="tabList">
                        <!-- <img class="tabImg" :src="item.head_image" alt="" /> -->
                        <img class="tabImg" v-bind:src="$getImageUrl(item.annex_file)" alt="" />

                        <div class="tabMid">
                            <div class="tabMidT1">{{ item.title }}</div>
                            <!-- 资源 -->
                            <div class="tabMidT2" v-if="item.type_data == '1'">
                                <div class="shengye">
                                    <span>学科：{{ (item.school_subject || {}).name }}</span>
                                    <span style="margin-left: 24px;">学段：{{ (item.school_subject || {}).grade_text }}</span>
                                    <span style="margin-left: 24px;">资源类型：{{ item.source_data_text }}</span>
                                    <span style="margin-left: 24px;">章节单元：{{ (item.school_unit || {}).name }} {{
                                        (item.school_chapter || {}).chapter_name }}</span><br />
                                </div>
                                <div>
                                    <!-- style="margin-left: 24px;" -->
                                    <span>作者：{{ item.user.username }}</span>
                                    <span style="margin-left: 24px;">上传时间：{{ item.createtime }}</span>
                                </div>
                            </div>
                            <!-- 试题 -->
                            <div class="tabMidT2" v-if="item.type_data == '2'">
                                <span>上传时间：{{ item.createtime }}</span>
                                <span style="margin-left: 24px;">作者：{{ item.user.username }}</span>
                                <span style="margin-left: 24px;">学段：{{ (item.school_subject || {}).grade_text }}</span>
                            </div>
                            <!-- 班会 -->
                            <div class="tabMidT2" v-if="item.type_data == '3'">
                                <span>类型：{{ item.class_meet_type == '1' ? "班会" : item.class_meet_type
                                    == '2' ? "家长会" :
                                    item.class_meet_type == '3' ? "班主任管理" : ""
                                }}</span>
                                <span v-if="item.class_meet_type == '1'">({{ item.class_meet_catgory == '1' ? "安全类" :
                                    item.class_meet_catgory
                                        == '2' ? "教育类" :
                                        item.class_meet_catgory == '3' ? "文化类" : ""
                                }})</span>
                                <span style="margin-left: 24px;">作者：{{ item.user.username }}</span>
                                <span style="margin-left: 24px;">上传时间：{{ item.createtime }}</span>
                            </div>
                        </div>
                    </div>
                    <!-- TODU 缺少审核状态 :1=待审核,2=已通过,3=驳回 -->
                    <div class="tabR" v-if="item.status == '1'">待审核</div>
                    <div class="tabR1" v-if="item.status == '2'">已通过</div>
                    <div class="tabR2" v-if="item.status == '3'">驳回</div>
                </div>
                <div class="line"></div>
                <div class="error_box" v-if="item.status == '3'">
                    <div class="title_box">驳回原因</div>
                    <div class="desc_box">{{ item.refuse_reason }}</div>
                </div>
            </div>

            <div v-if="bohui">
                <div class="tabView">
                    <div class="tabViewBlock">
                        <div class="tabList">
                            <!-- <img class="tabImg" :src="item.head_image" alt="" /> -->
                            <div class="tabMid">
                                <div class="tabMidT1">{{ item.title }}</div>
                                <!-- 资源 -->
                                <div class="tabMidT2" v-if="item.type_data == '1'">
                                    <span>学科：{{ (item.school_subject || {}).name }}</span>
                                    <span style="margin-left: 24px;">学段：{{ (item.school_subject || {}).grade_text }}</span>
                                    <span style="margin-left: 24px;">资源类型：{{ item.source_data_text }}</span>
                                    <!-- {{ item.school_chapter.chapter_name }} {{ item.school_unit.name }} -->
                                    <span style="margin-left: 24px;">章节单元：{{ (item.school_unit || {}).name }}</span><br />
                                    <!-- <div class="lbcd_item">作者：{{ item.user.username }}</div> -->
                                    <span style="margin-left: 24px;">作者：{{ item.user.username }}</span>
                                    <!-- <span>作者：{{userName}}</span> -->
                                    <span style="margin-left: 24px;">上传时间：{{ item.createtime }}</span>
                                </div>
                                <!-- 试题 -->
                                <div class="tabMidT2" v-if="item.type_data == '2'">
                                    <span>上传时间：{{ item.createtime }}</span>
                                    <span style="margin-left: 24px;">作者：{{ item.user.username }}</span>
                                    <span style="margin-left: 24px;">学段：{{ (item.school_subject || {}).grade_text }}</span>
                                </div>
                                <!-- 班会 -->
                                <div class="tabMidT2" v-if="item.type_data == '3'">
                                    <span>类型：{{ item.class_meet_type == '1' ? "班会" : item.class_meet_type
                                        == '2' ? "家长会" :
                                        item.class_meet_type == '3' ? "班主任管理" : ""
                                    }}</span>
                                    <span v-if="item.class_meet_type == '1'">({{ item.class_meet_catgory == '1' ? "安全类" :
                                        item.class_meet_catgory
                                            == '2' ? "教育类" :
                                            item.class_meet_catgory == '3' ? "文化类" : ""
                                    }})</span>
                                    <span style="margin-left: 24px;">作者：{{ item.user.username }}</span>
                                    <span style="margin-left: 24px;">上传时间：{{ item.createtime }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="tabR2">驳回</div>
                    </div>
                    <div class="line"></div>
                    <div class="error_box">
                        <div class="title_box">驳回原因</div>
                        <div class="desc_box">{{ item.refuse_reason }}</div>
                    </div>
                    <div class="error_box1">
                        <div class="ceshi">
                            <img :src="item.head_image" alt="" />
                            <div style="margin-left: 16px;">{{ item.file_name }}</div>
                        </div>
                        <div class="yulan" @click="viewVideoHandle(item.annex_file)">预览</div>
                    </div>
                    <div class="xiazai" @click="downVideo(item)">
                        <img src="@/assets/images/jiazai.png" alt="">
                        <div class="wenzi">下载附件</div>
                    </div>
                    <div class="gott" @click="goTTT(item)">再次提交</div>
                </div>
            </div>

            <el-empty v-if="!pageList.length" description="快去查看资源、试题、班会吧" style="margin-top: 200px;" />

            <div class="paginationView">
                <pagination v-if="total" :page.sync="page" :pageSize.sync="pageSize" :total="total" @change="pageChange" />
            </div>

        </div>
        <!-- 预览 -->
        <el-dialog title="视频预览" :visible.sync="showViewVideo">
            <!-- src="@/assets/demo.mp4" -->
            <video ref="video" :src="videoUrl" controls style="width:100%"></video>
        </el-dialog>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
export default {
    components: { Pagination },
    data() {
        return {
            page: 1,
            pageSize: 10,
            total: 0,
            currentPage4: 4,
            idx: 1,  //type_data 类型:1=资源,2=试题,3=班会
            userName: localStorage.getItem("username"),
            pageList: [],
            bohui: false,
            showViewVideo: false,
            videoUrl: "",
            item: {}
        }
    },
    mounted() {
        // 我的资源列表
        const query = this.$route.query;
        this.page = +query.page || 1;
        this.pageSize = +query.size || 10;
        this.getfollowList();
    },
    created() {

    },
    methods: {
        goTTT(item) {
            this.$router.push({
                path: "/home/upload",
                query: { data: JSON.stringify(item) }
            })
        },
        goXX(e) {
            console.warn(e, "++++++++++")
            if (e.status == '3') {
                this.bohui = true
                this.item = e

            }
        },
        // 下载视频
        downVideo(item = {}) {
            if (!item.annex_file) return this.$message.info('无效的下载链接')
            fetch(item.annex_file).then(res => res.blob()).then(blob => {
                const a = document.createElement('a');
                document.body.appendChild(a)
                a.style.display = 'none'
                const url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = item.title;
                a.click();
                document.body.removeChild(a)
                window.URL.revokeObjectURL(url);
                const res = this.$get('school_source/download', {
                    id: item.id,
                })
                console.debug(res)
            }).catch(err => {
                this.$message.error('下载fail，请稍后重试');
            })
        },
        /** 视频预览 */
        viewVideoHandle(url = "") {
            const isVideo = ['.rm', '.rmvb', '.wmv', '.asf', '.asx', '.mp4', '.3gp', '.mov', '.m4v', '.avi', '.dat', '.mkv', '.flv', '.vob',].some(item => ~url.indexOf(item));
            if (isVideo) {
                this.videoUrl = url;
                this.showViewVideo = true;
            } else window.open(url)
        },
        fade(e) {
            return e.split('/')[5]
        },

        // 切换类型
        goTab(e) {
            this.idx = e;
            this.page = 1;
            this.getfollowList();
        },
        /** 分页改变 */
        pageChange() {
            this.$router.replace(`/mine/index?page=${this.page}&size=${this.pageSize}`);
            this.getfollowList();
        },
        // 我的资源列表  tianyue.com/api/person_center/mysource?status=2
        /** 获取内容 */
        async getfollowList() {
            this.pageLoading = true;
            try {
                const res = await this.$get('person_center/mysource', {
                    pageNum: this.page,
                    pageSize: this.pageSize,
                    status: this.idx
                })
                this.pageList = res.data.data || [];
                this.total = res.data.total || 0;
                // console.warn(res, "res")
            } catch (error) { console.debug(error, 'err') }
            this.pageLoading = false;
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        }
    },
}
</script>

<style lang='scss' scoped>
.collectView {
    width: 100%;

    .collectBlock {
        margin: 37.5px 39px 163px 40px;

        .top {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .topA {
                font-size: 20px;
                font-family: PingFang SC, PingFang SC-Semibold;
                font-weight: 600;
                color: #333333;
            }

            .topB {
                display: flex;

                .topB1 {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 98px;
                    height: 32px;
                    border: 1px solid #d9242a;
                    background: #d9242a;
                    font-size: 14px;
                    font-family: PingFang SC, PingFang SC-Regular;
                    font-weight: 400;
                    color: #ffffff;
                }

                .topB2 {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 14px;
                    font-family: PingFang SC, PingFang SC-Regular;
                    font-weight: 400;
                    color: #d9242a;
                    background: #ffffff;
                    border: 1px solid #d9242a;
                    width: 98px;
                    height: 32px;
                }
            }
        }

        .paginationView {
            height: 100px;
            margin-top: 32px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .tabView {
            margin: 28px 0 0 0;

            .line {
                margin-top: 28px;
                width: 880px;
                height: 2px;
                background: #f2f2f2;
            }

            .error_box {
                background: #fdf3f4;
                margin-top: 16px;
                box-sizing: border-box;
                padding: 16px 24px;

                .title_box {
                    font-size: 18px;
                    font-family: PingFang SC, PingFang SC-Semibold;
                    font-weight: 600;
                    text-align: LEFT;
                    color: #d9242a;
                    margin-bottom: 8px;
                }

                .desc_box {
                    font-size: 16px;
                    font-family: PingFang SC, PingFang SC-Regular;
                    font-weight: 400;
                    text-align: LEFT;
                    color: #333333;
                }
            }

            .tabViewBlock {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .tabList {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 90%;

                    .tabImg {
                        width: 72px;
                        height: 72px;
                    }

                    .tabMid {
                        margin-left: 32px;

                        .tabMidT1 {
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            /*控制在3行*/
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: vertical;

                            font-size: 24px;
                            font-family: PingFang SC, PingFang SC-Semibold;
                            font-weight: 600;
                            color: #333333;
                        }

                        .tabMidT2 {
                            width: 680px;
                            margin-top: 16px;
                            line-height: 20px;
                            font-size: 16px;
                            font-family: PingFang SC, PingFang SC-Regular;
                            font-weight: 400;
                            color: #666666;
                        }
                    }
                }

                .tabR {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 60px;
                    height: 32px;
                    background: #e3e3e3;
                    font-size: 14px;
                    font-family: PingFang SC, PingFang SC-Regular;
                    font-weight: 400;
                    color: #666666;
                }

                .tabR1 {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 65px;
                    height: 32px;
                    background: #d5f2df;
                    font-size: 14px;
                    font-family: PingFang SC, PingFang SC-Regular;
                    font-weight: 400;
                    color: #259f4e;
                }

                .tabR2 {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 74px;
                    height: 32px;
                    background: #ffeeef;
                    font-size: 14px;
                    font-family: PingFang SC, PingFang SC-Regular;
                    font-weight: 400;
                    color: #d9242a;
                }
            }
        }
    }
}

.bohui {
    cursor: pointer;
    display: flex;
    // justify-content: center;
    align-items: center;

    img {
        width: 12px;
        height: 12px;
    }
}



.error_box1 {
    background: #fdf3f4;
    margin-top: 16px;
    box-sizing: border-box;
    padding: 16px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .ceshi {
        display: flex;
        align-items: center;

        img {
            width: 80px;
            height: 80px;
        }
    }


    .yulan {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 64px;
        height: 32px;
        background: #d9242a;
        border-radius: 2px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: #ffffff;
    }

    .title_box {
        font-size: 18px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        text-align: LEFT;
        color: #d9242a;
        margin-bottom: 8px;
    }

    .desc_box {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: LEFT;
        color: #333333;
    }
}

.xiazai {
    margin-top: 16px;
    display: flex;
    align-items: center;

    img {
        width: 20px;
        height: 20px;
    }

    .wenzi {
        font-size: 18px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: #d9242a;
    }
}

.gott {
    margin: 32px auto;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 142px;
    height: 32px;
    background: #d9242a;
    border: 1px solid #d9242a;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: #ffffff;
}

.shengye {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    /*控制在3行*/
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}
</style>
